import React, { Component } from 'react'
import { Alert } from 'antd'

export default class ProviderUsers extends Component<any, any> {
    render() {
        const { relatedUsers } = this.props
        let content
        if (relatedUsers) {
            if (relatedUsers.length > 0) {
                content = (
                    <Alert
                        message={<strong>{relatedUsers.length} משתמשים משוייכים למעסיק זה</strong>}
                        showIcon
                        type="warning"
                    />
                )
            } else {
                content = <Alert message="לא נמצאו משתמשים המשוייכים למעסיק זה" type="info" />
            }
        }
        return <div>{content}</div>
    }
}
